import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { CircularProgress, Stack } from "@mui/material";
import { values } from "underscore";

export default function SaveValidationModel(props) {
  const {
    open,
    savePopupMessage,
    ProjectDeatils,
    values1,
    handleSaveConfirm,
    removeItemFuncConfirm,
    buttonLoading,
  } = props;
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  console.log("removeItem", savePopupMessage);

  const regex = /from ([\d.]+)% to ([\d.]+)%/;
  const match = savePopupMessage?.thresholdDetails[0]?.description.match(regex);
  const fromValue = match?.[1];
  const toValue = match?.[2];
  return (
    <>
      <Dialog
        className="user-filter-popup project-filters"
        sx={{ width: "100%" }}
        fullScreen={fullScreen}
        open={open}
        //onClose={""}
        aria-labelledby="responsive-dialog-title"
      >
        <Stack
          sx={{ p: "25px 25px", pb: "15px" }}
          direction="row"
          alignItems="center"
          spacing={2}
          justifyContent="space-between"
        >
          <Typography className="model-title">Save Confirmation</Typography>
        </Stack>
        <Box sx={{ p: "0px 25px 0px 25px" }}>
          {/* Render message for details if it exists */}
          {savePopupMessage?.details?.length > 0 && (
            <Typography
              style={{ marginBottom: "20px" }}
              className="label"
              sx={{ fontSize: "15px", fontWeight: 450 }}
            >
              <span style={{ marginRight: "8px" }}>&bull;</span>
              Updating the project budget from $
              {Number(ProjectDeatils[0]?.NTEAmount || 0 || 0).toFixed(2)} to $
              {Number(values1?.nteAmount || 0).toFixed(2)} may trigger email
              notifications to recipients if any thresholds are exceeded. Are
              you sure you want to proceed?
            </Typography>
          )}

          {/* Render message for thresholdDetails based on its length */}
          {savePopupMessage?.thresholdDetails?.length > 0 && (
            <>
              {savePopupMessage.thresholdDetails.length === 1 ? (
                <Typography
                  style={{ marginBottom: "20px" }}
                  className="label"
                  sx={{ fontSize: "15px", fontWeight: 450 }}
                >
                  <span style={{ marginRight: "8px" }}>&bull;</span>
                  Updating the threshold from {fromValue}% to {toValue}% may
                  trigger an email if exceeded, unless a higher threshold was
                  already notified. Proceed?
                </Typography>
              ) : (
                <Typography
                  style={{ marginBottom: "10px" }}
                  className="label"
                  sx={{ fontSize: "15px", fontWeight: 450 }}
                >
                  <span style={{ marginRight: "8px" }}>&bull;</span>
                  Updating multiple thresholds may trigger emails if exceeded,
                  unless a higher threshold was already notified. Proceed?
                </Typography>
              )}
            </>
          )}
        </Box>

        <DialogActions
          sx={{ justifyContent: "flex-start", p: "20px 25px", pt: "25px" }}
        >
          <Button
            className={buttonLoading ? "disable-filter-btn" : "filter-btn"}
            onClick={handleSaveConfirm}
            disabled={buttonLoading}
          >
            {buttonLoading && (
              <CircularProgress
                color={"inherit"}
                size={10}
                sx={{ marginRight: "3px" }}
              />
            )}
            Yes
          </Button>
          <Button className="cancel-btn" onClick={removeItemFuncConfirm}>
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
